import { Box } from '@mui/material';

const MainLayout = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        minHeight: '100vh',
        marginTop: '-10px',
        marginRight: '-10px',
      }}
    >
      {children}
    </Box>
  );
};

export default MainLayout;
